import {  createTheme, responsiveFontSizes  } from '@material-ui/core/styles';

const main = {
    primary: "#060825",
    secondary: "#414141",
    error: "#ff0000",
    background: "#ffffff",
}

export const mainTheme =  createTheme ({
    typography: {
        allVariants: {
            fontFamily: 'Aptos'
        },
        cardTitleCustomStyle: {
            fontSize: "10rem"
        },
        poster: {
            fontSize: "10rem",
            color: 'red',
          },
    },
    palette: {
        primary: { main: main.primary },
        secondary: { main: main.secondary },
        error: { main: main.error }

    },
    overrides: {
        // TODO: Go on a hunt to replace Roboto fonts with Source Sans Pro
        MuiTypography: {
            root:{
                fontFamily: '"sans-serif","Source Sans Pro", "Roboto", "Helvetica", "Arial" ',
            },
            colorSecondary: {
                margin: "0.5rem 0"
            },
            colorError: {
                margin: "0.5rem 0"
            },
            body2: {
                fontSize: "1.3rem"
            },

        },
        MuiButton: {
            root: {
                fontFamily: '"sans-serif","Source Sans Pro", "Roboto", "Helvetica", "Arial" ',
                fontSize: "1rem",
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: "4px",
                margin: "4px 8px",
                "&&$disabled": {
                    backgroundColor: main.disabled
                },
                "&&$contained": {
                    boxShadow: true,
                    color: "#ffffff"
                },
                "&&$outlinedPrimary": {
                    borderColor: main.primary
                },
                "&&$outlinedSecondary": {
                    borderColor: main.secondary
                }
            },
            sizeLarge: {
                fontSize: "1.3rem",
                minWidth: "12rem",
                minHeight: "3.5rem"
            },
            text: {
                fontSize: "1.25rem"
            },
            contained: {},
            outlinedPrimary: {},
            outlinedSecondary: {},
            disabled: {}
        },
        MuiInputBase: {
            root: {
                fontSize: "1.5rem",
                // fontWeight: "bold"
            }
        },
        MuiFormControl: {
            root: {
                margin: "1.5rem 0rem"
            }
        },

        MuiCheckbox: {
            colorPrimary: {
                color: main.primary
            }
        },
        MuiOutlinedInput: {
            root: {
                width: "8rem",
                height: "2.5rem"
            },
            input: {
                padding: "9px 7px"
            },
            adornedEnd: {
                width: "13rem"
            }
        },
        MuiIconButton: {
            root: {
                padding: "6px 16px"
            }
        },

        MuiTable: {
            root: {
                marginTop: "2rem",
                fontFamily: '"Source Sans Pro", "Roboto", "Helvetica", "Arial", sans-serif'
            },
        },
        MuiTableCell: {
            body: {
                fontSize: "1rem",
            },
            head: {
                color: "#000",
                fontSize: "1rem",
                fontWeight: "lighter",
                verticalAlign: "bottom",
                borderBottom: "1px solid rgb(162, 162, 162)",
                paddingBottom: "10px"
            }
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        }
    }
});
